import { DatePicker, type DatePickerProps } from '../DatePicker/DatePicker';
import DateRangePresets from './DateRangePresets';

interface DateRangePickerProps {
  start: DatePickerProps;
  end: DatePickerProps;
}

export const DateRangePicker = ({ start, end }: DateRangePickerProps) => {
  return (
    <>
      <div className="flex flex-col w-full grid-cols-3 gap-2 lg:grid ">
        <DatePicker
          label="From"
          selectsStart
          startDate={start.selected ?? undefined}
          endDate={end.selected ?? undefined}
          {...start}
        />
        <DatePicker
          label="To"
          selectsEnd={!!start.selected}
          startDate={start.selected ?? undefined}
          minDate={start.selected ?? undefined}
          endDate={end.selected ?? undefined}
          {...end}
        />

        <DateRangePresets />
      </div>
    </>
  );
};
